module.exports = __webpack_public_path__ + "img/javis.8913913b.png";